
































import { Component, Prop, Vue } from "../vuepack";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import { CognitoAuth as Auth } from "@/shared/api/auth";
import { AuthenticationDetails, CognitoUserSession } from "amazon-cognito-identity-js";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import { MfaManageStep, MfaStatusEnum } from "@/shared/types";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { useMfaStore } from "@/shared/store/mfa";

@Component({
  components: {
    LoginWrapper,
    Input,
    Button
  }
})
export default class MfaWidget extends Vue {
  userStore = useUserStore();
  notifierStore = useNotifierStore();
  mfaStore = useMfaStore();

  @Prop()
  Username: string;

  @Prop()
  Password: string;

  @Prop({ default: true })
  IsLogin: boolean;

  @Prop()
  MfaType: MfaStatusEnum;

  get isLogin () {
    return this.IsLogin;
  }

  model = {
    mfaToken: ""
  };

  submitDisabled = false;

  authenticationDetails: AuthenticationDetails;

  getCallbacks () {
    return {
      onSuccess: (s: CognitoUserSession) => {
        if (!this.isLogin) {
          this.mfaStore.setStep(MfaManageStep.PostMfa);
          return;
        }

        Auth().postLoginProcess(new Promise((resolve, _) => resolve(s)),
          this.Username,
          this.userStore.groupsForLogin,
          this.mfaStore.cognitoUser)
          .then(u => this.userStore.processLogin(u));
        this.mfaStore.setCognitoUser(null);
      },
      onFailure: _ => {
        this.notifierStore.setDanger("Could not verify the submitted token.");
        this.submitDisabled = false;
      }
    };
  }

  triggerSms () {
    // expecting a failure since all we're trying to do is get another sms
    const callbacks = this.getCallbacks();
    callbacks.onFailure = () => {
      // linter
    };
    this.notifierStore.setSuccess("Verification code re-sent");
    this.mfaStore.cognitoUser.authenticateUser(this.authenticationDetails, callbacks);
  }

  get isSms () {
    return this.MfaType === MfaStatusEnum.Sms;
  }

  mounted () {
    this.authenticationDetails = new AuthenticationDetails({
      Username: this.Username,
      Password: this.Password
    });
  }

  onSubmit () {
    this.submitDisabled = true;
    const token = this.model.mfaToken;
    const callbacks = this.getCallbacks();
    if (this.MfaType === MfaStatusEnum.Sms) {
      this.mfaStore.cognitoUser.sendMFACode(token, callbacks);
      return;
    }

    this.mfaStore.cognitoUser.sendMFACode(token, callbacks, "SOFTWARE_TOKEN_MFA");
  }
}
